/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type SwiperItem_photo = {
    readonly placeholder: string | null;
    readonly smallPath: string | null;
    readonly masterOrZoomPath: string | null;
    readonly " $refType": "SwiperItem_photo";
};
export type SwiperItem_photo$data = SwiperItem_photo;
export type SwiperItem_photo$key = {
    readonly " $data"?: SwiperItem_photo$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SwiperItem_photo">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SwiperItem_photo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "placeholder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterOrZoomPath",
      "storageKey": null
    }
  ],
  "type": "ItemPhoto",
  "abstractKey": null
};
(node as any).hash = '34c12a755b941c91ba57f76a5619775a';
export default node;
